<template>
  <footer class="footer text-small">
    <div>
      {{ T('Powered by') }}

      <FhAsset width="90px" :asset="fareharborTypeOnly" />
    </div>
  </footer>
</template>

<script setup>
import { FhAsset } from '@fareharbor-com/beacon-vue';
import { fareharborTypeOnly } from '@fareharbor-com/beacon-vue/assets';
</script>

<style scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: var(--fh-border-sm) solid var(--fh-color-border-default);
  color: var(--fh-color-text-primary-default);
  height: 48px;
  box-sizing: border-box;
}
</style>
